import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { SummaryBlock } from './SummaryBlock';
import { useSiteState, useStyleStore } from '../../state/state';

export const SiteHeader = () => {
    const history = useHistory();
    const { token } = useParams<Token>();
    const { headerDesign } = useStyleStore();
    const { name, settings } = useSiteState();
    const [clickable, setClickable] = useState(false);

    const onLogoClick = () => {
        if (token && clickable) {
            history.replace(`/welcome/${token}`);
        }
    };

    useEffect(() => {
        if (token && history && setClickable) {
            if (history.location.pathname !== `/welcome/${token}`) {
                setClickable(true);
            }
        }
    }, [history, token]);

    return (
        <SummaryBlock display className="summary-block text-center">
            <div onClick={onLogoClick} className={clickable ? 'clickable' : ''}>
                <div className={`design-${headerDesign}`}>
                    {headerDesign == 1 ? settings?.headerText : name}
                </div>
                <div className={`sub-design-${headerDesign}`}>
                    {headerDesign == 1 ? name : settings?.headerText}
                </div>
            </div>
        </SummaryBlock>
    );
}
